export default {
    setUserDetail(state, usr_detail)
    {
        state.UserDetailList = usr_detail
    },
    setUserSession(state, usr_session)
    {
        state.UserSession = usr_session
    },
    setUserApplication(state, usr_application)
    {
        state.UserApplicationList = usr_application
    },
    SetUserState(state, payload)
    {
        state.State = payload
    },
    setAutoLogout(state){
        state.didAutoLogout = true;
        state.isAuthorized = false;
    },
    setOnline(state, payload){
        state.isOnline = payload.online;
    },
    setIsAuthorized(state, payload){
        state.isAuthorized = payload;
    },
    setAppToken(state, payload){
        state.UserSession.app_token = payload;
    },
    setIsAuthenticated(state, payload) {
        state.isAuthenticated = payload;
    },
    setShowSessionExpiredModal(state, payload) {
        state.showSessionExpiredModal = payload;
    }
};